import { Link as ReactRouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import ActionButton from 'components/action-button';
import SanityBlockContent from 'components/roll-up-the-rim/typography/sanity-block-content';

const HeaderStyles = (style?: string) => `
  color: ${Styles.color.white};
  font-size: 2.45rem;
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.black};
  text-align: center;
  letter-spacing: -1.79px;
  line-height: 1.125;
  margin-top: 0;
  margin-bottom: 1rem;
  ${style}
`;

const h1Style = `h1 {
  font-size: 2.45rem;
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.black};
}`;

export const HeaderBlockContent = styled(SanityBlockContent)`
  ${HeaderStyles(h1Style)}
`;

export const Header = styled.div`
  ${HeaderStyles()}
`;

export const Subheader = styled.h2`
  color: ${Styles.color.white};
  font-size: 1.75rem;
  font-family: ${Styles.fontFamily.base};
  font-weight: bold;
  text-align: center;
  letter-spacing: -0.42px;
  line-height: 1.3;
  margin-top: 0;
`;

const BodyStyles = css`
  color: ${Styles.color.white};
  font-size: 1.2rem;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
  letter-spacing: -0.3px;
  line-height: 1.3;
  margin-bottom: 0;
`;

export const Body = styled.p`
  ${BodyStyles}
`;

export const BodyBlockContent = styled(SanityBlockContent)`
  ${BodyStyles}
`;

export const Content = styled.p`
  color: ${Styles.color.white};
  font-size: 1rem;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
  /* letter-spacing: -0.3px; */
  line-height: 1.3;
  margin-bottom: 0;
`;

const LinkStyles = css`
  ${BodyStyles}
  font-weight: ${Styles.fontWeight.heavy};
  display: inline-block;
  margin-top: 1rem;
  position: relative;
  text-decoration: underline;

  &::after {
    display: block;
    position: absolute;
    right: 0px;
    top: 50%;
    content: '';
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-left: 5px solid ${Styles.color.white};
    transform: translate(200%, -50%);
  }
`;

export const Link = styled(ReactRouterLink)`
  ${LinkStyles}
`;

// NOT IN USE ANYWHERE
export const LinkButton = styled(ActionButton)`
  &,
  &:hover {
    background: transparent;
    width: auto;
  }
  ${LinkStyles}
`;
